/**
 * This file should not be used directly by MFEs! This requires config override and i18n to be setup. Please include
 * curatedListingsEntry instead and call the init method from MFE consumer.
 */

import AceButton from 'ace/button';
import Link from 'ads/link';
import AuthorByline from 'mfe/authorByline';
import Banner from 'mfe/banner';
import ContentCard from 'mfe/contentCard';
import CuratedListings from 'mfe/curatedListings';
import CuratedListingTile from 'mfe/curatedListingTile';
import Stats from 'mfe/stats';

customElements.define('cms-curated-listings', CuratedListings.CustomElementConstructor);

customElements.define('cms-curated-listing-tile', CuratedListingTile.CustomElementConstructor);

customElements.define('cms-author-byline', AuthorByline.CustomElementConstructor);
customElements.define('cms-content-card', ContentCard.CustomElementConstructor);
customElements.define('cms-banner', Banner.CustomElementConstructor);
customElements.define('cms-link', Link.CustomElementConstructor);
// Analytics insturmentation is handled by the AceButton component. (cms-wp-button is used for the WP Block Editor only. No analytics instrumentation. - see cmsElements)
customElements.define('cms-button', AceButton.CustomElementConstructor);
customElements.define('cms-stats', Stats.CustomElementConstructor);
